var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"o-icon"},[_c(_vm.src,{tag:"component",class:_vm.srcClass,style:(_vm.style)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }